/**
 * The Apple Calendar feed's answer, and where its press may send the browser (owner, 28 October
 * 2026): Calendar's own `webcal:` subscription handler and nowhere else. Pure.
 */

export interface CalendarFeedRead {
  readonly available: boolean;
  readonly enabled: boolean;
  readonly webcalUrl?: string | null;
  readonly lastFetchedAt?: string | null;
}

/** The one scheme the page may be sent to from the feed's answer: Calendar's subscription handler. */
export function isWebcalUrl(url: string | null | undefined): url is string {
  if (typeof url !== 'string' || !/^webcal:\/\/[^/?#\s]/i.test(url)) return false;
  try {
    return new URL(url).protocol === 'webcal:';
  } catch {
    return false;
  }
}

/** Where the button sends the browser now: the address in hand, or `null` — enable first. */
export function subscribeTarget(read: CalendarFeedRead | undefined): string | null {
  return read?.enabled === true && isWebcalUrl(read.webcalUrl) ? read.webcalUrl : null;
}
